module.exports = __webpack_public_path__ + "img/score-bg.2a914f4.png";